import React from "react";
import {css} from "@panda/css";
import {isBefore, parseISO} from "date-fns";

import {Container} from "@pg-design/grid-module";
import {AirportIcon, AreaIcon, BeachIcon, BookmarkIcon, CalendarCheckIcon, CityIcon, FloorsIcon, LikeIcon, RoomsIcon} from "@pg-design/icons-module";
import {dateTimeFormat, formatDate, formatRange} from "@pg-mono/string-utils";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {Country} from "../../region/types/Country";
import {useOfferStandardDescription} from "../detail/hooks/use_offer_standard_description";
import {IOfferDetail} from "../types/IOfferDetail";
import {UVP} from "./UVP";

interface IProps {
    offer: IOfferDetail;
    standardType: IValueLabel[] | string;
}

interface IValueLabel {
    label: string;
    value: number;
}

export const OfferUVP = (props: IProps) => {
    const {offer} = props;

    const standard = useOfferStandardDescription(offer.standard_description);

    const area = formatRange([offer.stats?.ranges_area_min, offer.stats?.ranges_area_max]);
    const floors = formatRange([offer.floors_above_ground_range?.lower, offer.floors_above_ground_range?.upper]);
    const underConstruction = isBefore(new Date(), parseISO(offer.construction_date_range.upper));
    const constructionDate = formatDate(offer.construction_date_range.upper, dateTimeFormat.quarter);
    const abroadOffer = offer.region.country !== Country.POLAND;
    const distanceFromTheAirport = offer.distance_from_the_airport ? distanceFromFormat(offer.distance_from_the_airport) : null;
    const distanceFromTheBeach = offer.distance_from_the_beach ? distanceFromFormat(offer.distance_from_the_beach) : null;

    return (
        <Container className={containerStyle} data-testid={OFFER_TEST_IDS.OFFER_VIEW.OFFER_KEY_DETAILS_SECTION}>
            <div className={uvpsStyle}>
                {constructionDate && (
                    <UVP
                        icon={<CalendarCheckIcon size="4" />}
                        label="Termin oddania"
                        value={underConstruction ? constructionDate : "Gotowe"}
                        dataTestId={OFFER_TEST_IDS.OFFER_VIEW.CONSTRUCTION_DEADLINE_VALUE}
                    />
                )}
                {area && (
                    <UVP
                        icon={<AreaIcon size="4" />}
                        label="Powierzchnie"
                        value={
                            <>
                                {area}/m<sup>2</sup>
                            </>
                        }
                        dataTestId={OFFER_TEST_IDS.OFFER_VIEW.AREA_RANGE_VALUE}
                    />
                )}
                <UVP
                    icon={<RoomsIcon size="4" />}
                    label="Przedział pokoi"
                    value={getRoomsRange(offer)}
                    dataTestId={OFFER_TEST_IDS.OFFER_VIEW.ROOMS_RANGE_VALUE}
                />
                {abroadOffer && (
                    <>
                        {distanceFromTheAirport && <UVP icon={<AirportIcon size="4" />} label="Odległość od lotniska" value={distanceFromTheAirport} />}
                        {distanceFromTheBeach && <UVP icon={<BeachIcon size="4" />} label="Odległość od morza" value={distanceFromTheBeach} />}
                        <UVP
                            icon={<LikeIcon size="4" />}
                            label="Pozwolenie na wynajem"
                            popover="W Hiszpanii nie wszystkie nieruchomości mogą być wynajmowane w celach komercyjnych. Przed podjęciem decyzji o wynajmie, upewnij się, czy dana nieruchomość spełnia lokalne wymogi prawne dotyczące wynajmu komercyjnego."
                            value={["Nie", "Tak"][Number(offer.commercial_rental)]}
                        />
                    </>
                )}
                {floors && <UVP icon={<FloorsIcon size="4" />} label="Kondygnacje" value={floors} dataTestId={OFFER_TEST_IDS.OFFER_VIEW.FLOORS_NUMBER_VALUE} />}
                {offer.buildings && (
                    <UVP icon={<CityIcon size="4" />} label="Budynki" value={offer.buildings} dataTestId={OFFER_TEST_IDS.OFFER_VIEW.BUILDINGS_NUMBER_VALUE} />
                )}
                <UVP
                    icon={<BookmarkIcon size="4" />}
                    label="Stand. wykończenia"
                    value={standard}
                    dataTestId={OFFER_TEST_IDS.OFFER_VIEW.FINISHING_STANDARD_VALUE}
                />
            </div>
        </Container>
    );
};

//  Utils
function getRoomsRange(offer: IOfferDetail) {
    if (offer.stats && Array.isArray(offer.stats.rooms) && offer.stats.rooms.length > 1) {
        return `${Math.min(...offer.stats.rooms)} - ${Math.max(...offer.stats.rooms)}`;
    }

    if (offer.stats && Array.isArray(offer.stats.rooms) && offer.stats.rooms.length === 1) {
        return offer.stats.rooms[0];
    }

    return "-";
}

export const distanceFromFormat = (value: number) => {
    const kilometres = value / 1000;
    const metres = value % 1000;

    return kilometres >= 1 ? kilometres.toFixed(Number(!!metres)) + " km" : metres + " m";
};

//  Styles
const containerStyle = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    mt: 3,
    mb: 3,

    md: {
        mt: 6,
        mb: 2
    }
});

const uvpsStyle = css({
    display: "flex",
    flexWrap: "wrap",
    w: "100%",
    justifyContent: "center",
    alignItems: "flex-start",
    px: 2,

    md: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(16rem, auto))",
        gridTemplateRows: "auto"
    },

    lg: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "nowrap"
    }
});
import React from "react";
import {css} from "@panda/css";
import {isBefore, parseISO} from "date-fns";

import {Container} from "@pg-design/grid-module";
import {AirportIcon, AreaIcon, BeachIcon, BookmarkIcon, CalendarCheckIcon, CityIcon, FloorsIcon, LikeIcon, RoomsIcon} from "@pg-design/icons-module";
import {dateTimeFormat, formatDate, formatRange} from "@pg-mono/string-utils";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {Country} from "../../region/types/Country";
import {useOfferStandardDescription} from "../detail/hooks/use_offer_standard_description";
import {IOfferDetail} from "../types/IOfferDetail";
import {UVP} from "./UVP";

interface IProps {
    offer: IOfferDetail;
    standardType: IValueLabel[] | string;
}

interface IValueLabel {
    label: string;
    value: number;
}

export const OfferUVP = (props: IProps) => {
    const {offer} = props;

    const standard = useOfferStandardDescription(offer.standard_description);

    const area = formatRange([offer.stats?.ranges_area_min, offer.stats?.ranges_area_max]);
    const floors = formatRange([offer.floors_above_ground_range?.lower, offer.floors_above_ground_range?.upper]);
    const underConstruction = isBefore(new Date(), parseISO(offer.construction_date_range.upper));
    const constructionDate = formatDate(offer.construction_date_range.upper, dateTimeFormat.quarter);
    const abroadOffer = offer.region.country !== Country.POLAND;
    const distanceFromTheAirport = offer.distance_from_the_airport ? distanceFromFormat(offer.distance_from_the_airport) : null;
    const distanceFromTheBeach = offer.distance_from_the_beach ? distanceFromFormat(offer.distance_from_the_beach) : null;

    return (
        <Container className={containerStyle} data-testid={OFFER_TEST_IDS.OFFER_VIEW.OFFER_KEY_DETAILS_SECTION}>
            <div className={uvpsStyle}>
                {constructionDate && (
                    <UVP
                        icon={<CalendarCheckIcon size="4" />}
                        label="Termin oddania"
                        value={underConstruction ? constructionDate : "Gotowe"}
                        dataTestId={OFFER_TEST_IDS.OFFER_VIEW.CONSTRUCTION_DEADLINE_VALUE}
                    />
                )}
                {area && (
                    <UVP
                        icon={<AreaIcon size="4" />}
                        label="Powierzchnie"
                        value={
                            <>
                                {area}/m<sup>2</sup>
                            </>
                        }
                        dataTestId={OFFER_TEST_IDS.OFFER_VIEW.AREA_RANGE_VALUE}
                    />
                )}
                <UVP
                    icon={<RoomsIcon size="4" />}
                    label="Przedział pokoi"
                    value={getRoomsRange(offer)}
                    dataTestId={OFFER_TEST_IDS.OFFER_VIEW.ROOMS_RANGE_VALUE}
                />
                {abroadOffer && (
                    <>
                        {distanceFromTheAirport && <UVP icon={<AirportIcon size="4" />} label="Odległość od lotniska" value={distanceFromTheAirport} />}
                        {distanceFromTheBeach && <UVP icon={<BeachIcon size="4" />} label="Odległość od morza" value={distanceFromTheBeach} />}
                        <UVP
                            icon={<LikeIcon size="4" />}
                            label="Pozwolenie na wynajem"
                            popover="W Hiszpanii nie wszystkie nieruchomości mogą być wynajmowane w celach komercyjnych. Przed podjęciem decyzji o wynajmie, upewnij się, czy dana nieruchomość spełnia lokalne wymogi prawne dotyczące wynajmu komercyjnego."
                            value={["Nie", "Tak"][Number(offer.commercial_rental)]}
                        />
                    </>
                )}
                {floors && <UVP icon={<FloorsIcon size="4" />} label="Kondygnacje" value={floors} dataTestId={OFFER_TEST_IDS.OFFER_VIEW.FLOORS_NUMBER_VALUE} />}
                {offer.buildings && (
                    <UVP icon={<CityIcon size="4" />} label="Budynki" value={offer.buildings} dataTestId={OFFER_TEST_IDS.OFFER_VIEW.BUILDINGS_NUMBER_VALUE} />
                )}
                <UVP
                    icon={<BookmarkIcon size="4" />}
                    label="Stand. wykończenia"
                    value={standard}
                    dataTestId={OFFER_TEST_IDS.OFFER_VIEW.FINISHING_STANDARD_VALUE}
                />
            </div>
        </Container>
    );
};

//  Utils
function getRoomsRange(offer: IOfferDetail) {
    if (offer.stats && Array.isArray(offer.stats.rooms) && offer.stats.rooms.length > 1) {
        return `${Math.min(...offer.stats.rooms)} - ${Math.max(...offer.stats.rooms)}`;
    }

    if (offer.stats && Array.isArray(offer.stats.rooms) && offer.stats.rooms.length === 1) {
        return offer.stats.rooms[0];
    }

    return "-";
}

export const distanceFromFormat = (value: number) => {
    const kilometres = value / 1000;
    const metres = value % 1000;

    return kilometres >= 1 ? kilometres.toFixed(Number(!!metres)) + " km" : metres + " m";
};

//  Styles
const containerStyle = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    mt: 3,
    mb: 3,

    md: {
        mt: 6,
        mb: 2
    }
});

const uvpsStyle = css({
    display: "flex",
    flexWrap: "wrap",
    w: "100%",
    justifyContent: "center",
    alignItems: "flex-start",
    px: 2,

    md: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(16rem, auto))",
        gridTemplateRows: "auto"
    },

    lg: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "nowrap"
    }
});
